module.exports = __webpack_public_path__ + "static/media/thuiswinkel_waarborg.b2c49d0c.svg";